import { InfoCircle } from "components/icons/generated";
import Callout from "ds/components/Callout";
import Box from "ds/components/Box";
import Link from "ds/components/Link";
import FeedbackActions from "ds/components/Feedback/Actions";

const BlueprintsSelfServiceCallout = () => {
  return (
    <Callout variant="info" icon={InfoCircle} storageKey="blueprintsSelfServiceCallout">
      <Box direction="column" gap="medium" align="start">
        <Box direction="column" gap="small">
          <strong>Try the new Self-service feature!</strong>
          <span>
            We've released an improved self-service experience with versioned templates and better
            deployment tracking. Explore our new templates and see how they can simplify your
            workflow.
          </span>
        </Box>
        <FeedbackActions>
          <Link href="/templates-workbench">Explore templates</Link>
        </FeedbackActions>
      </Box>
    </Callout>
  );
};

export default BlueprintsSelfServiceCallout;
